import { useContext } from 'react';

import type { Me } from '../api/types';
import { SessionContext } from './SessionProvider';
import type { SessionContextValue } from './SessionProvider';

export function useSession(): SessionContextValue {
    const value = useContext(SessionContext);

    if (value === null) {
        throw new Error('useSession() hors de <SessionProvider>.');
    }

    return value;
}

/**
 * Le compte connecté, pour les écrans qui ne se montent QUE dans la coquille.
 * Les monter ailleurs est une faute de routage, qu'il vaut mieux voir tout de
 * suite qu'afficher comme un écran vide.
 */
export function useMe(): Me {
    const { session } = useSession();

    if (session.status !== 'active') {
        throw new Error('useMe() hors d\'une session active.');
    }

    return session.me;
}

/** Le compte connecté détient-il cette permission ? Pour afficher, jamais pour autoriser. */
export function useCan(permission: string): boolean {
    return useMe().permissions.includes(permission);
}
